'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { useSavedUtmParams } from './useSavedUtmParams';

import { applyUtmParamsToHref } from '@/shared/utils/utmLinks';
import { getUtmProduct } from '@/shared/utils/utmParams';

/** Сигнатура продукта для штампа меток — по текущей странице */
export const useUtmProduct = () => getUtmProduct(usePathname() ?? '/');

/** Ссылка с сохранёнными UTM-метками со штампом `__dev.2gis-{продукт}` */
export const useUtmHref = (href?: string | null) => {
  const utmParams = useSavedUtmParams();
  const product = useUtmProduct();

  return useMemo(
    () => (href ? applyUtmParamsToHref(href, utmParams, product) : undefined),
    [href, utmParams, product],
  );
};
